import { css } from "@emotion/css";
import { SearchInput, useDebouncedCallback } from "@octopusdeploy/design-system-components";
import { useEffect } from "react";
import * as React from "react";
import { Skeleton } from "~/areas/projects/components/Projects/Skeleton";
interface ProjectDashboardSearchBoxProps {
    searchValue?: string;
    onSearchValueChange: (newValue: string) => void;
}
export function ProjectsDashboardSearchBox({ searchValue, onSearchValueChange }: ProjectDashboardSearchBoxProps) {
    const [internalSearchValue, setInternalSearchValue] = React.useState(searchValue ?? "");
    const debouncedOnSearchValueChange = useDebouncedCallback(() => onSearchValueChange(internalSearchValue), 200);
    useEffect(() => {
        if (searchValue) {
            setInternalSearchValue(searchValue);
        }
    }, [searchValue]);
    const internalOnSearchValueChange = (newValue: string) => {
        setInternalSearchValue(newValue);
        if (newValue === "") {
            debouncedOnSearchValueChange.cancel();
            onSearchValueChange("");
        }
        else {
            debouncedOnSearchValueChange();
        }
    };
    return <SearchInput autoFocus={true} value={internalSearchValue} onChange={internalOnSearchValueChange} accessibleName={"search project or project group"} placeholder={"Find projects or project groups"}/>;
}
export function ProjectsDashboardSearchBoxSkeleton() {
    return (<div className={searchInputSkeletonStyles}>
            <Skeleton shape={"Rounded"} borderRadius={"small"}/>
        </div>);
}
const searchInputSkeletonStyles = css({
    width: "19rem",
    height: "2.25rem",
});
